import {Helmet} from "react-helmet";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from "./pages/LandingPage";
import SMSMessaging from "./pages/SMSMessaging";
import USSDMessaging from "./pages/USSDMessaging";
import Airtime from "./pages/Airtime";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import DevelopersPage from "./pages/DevelopersPage";
import Pricing from "./pages/Pricing";




function App() {

  return (
    <div>
        <Helmet>
                <title>Whistle Pulse - The Pan African Messaging Platform</title>
                <link rel="canonical" href="https://whistlepulse.com/" />
                {/* <!-- Required Meta Tags Always Come First --> */}
  <meta name="robots" content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
  <link rel="canonical" href="https://whistlepulse.com/"/>
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
  <meta name="description" content="Whistle Pulse provides an API-first messaging platform for businesses to send bulk and personalized messages over SMS, Voice, Whatsapp Business, USSD etc. across Africa."/>

  <meta name="twitter:site" content="@WhistlePulseHQ"/>
  <meta name="twitter:creator" content="@WhistlePulseHQ"/>
  <meta name="twitter:card" content="summary_large_image"/>
  <meta name="twitter:title" content="Whistle Pulse - The Pan African Messaging Platform"/>
  <meta name="twitter:description" content="Whistle Pulse provides an API-first messaging platform for businesses to send bulk and personalized messages over SMS, Voice, Whatsapp Business, USSD etc. across Africa."/>
  <meta name="twitter:image" content="https://whistlepulse.com/static/images/logo-full-dark.png"/>

  <meta property="og:url" content="https://whistlepulse.com/"/>
  <meta property="og:locale" content="en_US"/>
  <meta property="og:type" content="website"/>
  <meta property="og:site_name" content="Whistle Pulse"/>
  <meta property="og:title" content="Whistle Pulse - The Pan African Messaging Platform"/>
  <meta property="og:description" content="Whistle Pulse provides an API-first messaging platform for businesses to send bulk and personalized messages over SMS, Voice, Whatsapp Business, USSD etc. across Africa."/>
  <meta property="og:image" content="https://whistlepulse.com/static/images/logo-full-dark.png"/>
  <title>The Pan-African Messaging Platform</title>
            </Helmet>

            <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/sms-messaging" element={<SMSMessaging />} />
        <Route path="/ussd-messaging" element={<USSDMessaging />} />
        <Route path="/airtime-purchase" element={<Airtime />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/developers" element={<DevelopersPage />} />
        <Route path="/pricing" element={<Pricing />} />
        {/* <Route path="/settings" element={<Settings />} /> */}
      </Routes>
    </Router>
     <ScrollToTop/>
    </div>
  );
}

export default App;
